module.exports = __webpack_public_path__ + "img/mentalHealthWhite.ca9498ec.svg";